import * as React from 'react'
import './styles.css'
// libs
import { motion } from 'motion/react'
// components
import Glow from '../../../../glows'
import LearnMoreButton from '../../../../ui/LearnMoreButton'
import AnimatedContainer from '../../../../ui/AnimatedContainer/animatedContainer'
// views
import {
  titleAnimation,
  subtitleAnimation,
} from '../../../../../constants/animation'
// assets
import { ReactComponent as CheckIcon } from '../../../../../assets/imgs/recruting/feather-check.svg'
import { ReactComponent as SeeingIsBelievingScene } from '../../../../../assets/imgs/alumni/seeing-is-believing.svg'

const POD_SEEING_IS_BELIEVING_DATA = [
  'AI can identify overlapping focus and interest among your network ',
  'Students and alumni can connect for mentorships, internships and jobs',
  'Prospective students and their parents can explore the power of your network',
]

const SeeingIsBelievingSection = () => {
  return (
    <section className='alumni-content'>
      <div className='box'>
        <Glow position='right' />

        <AnimatedContainer
          className='alumni-grid-container seeing-is-believing-grid-ext'
          mountOnEnter
        >
          <div className='seeing-is-believing-section'>
            <SeeingIsBelievingScene />
          </div>
          <div className='seeing-is-believing-right-content'>
            <motion.p
              className='recruiting-main-title'
              variants={titleAnimation}
            >
              Seeing is Believing
            </motion.p>
            <motion.p
              className='recruiting-sub-content-container'
              variants={subtitleAnimation}
            >
              {POD_SEEING_IS_BELIEVING_DATA.map((text, index) => (
                <div key={index} className='recruiting-sub-content'>
                  <div className='recruiting-sub-content-icon'>
                    <CheckIcon />
                  </div>
                  <div>{text}</div>
                </div>
              ))}
            </motion.p>
            <div className='recruiting-button-container'>
              <LearnMoreButton />
            </div>
          </div>
        </AnimatedContainer>
      </div>
    </section>
  )
}

export default SeeingIsBelievingSection
